/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Lost_IncomeInputs */

const en_reports_col_lost_income = /** @type {(inputs: Reports_Col_Lost_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost income`)
};

const pt_br2_reports_col_lost_income = /** @type {(inputs: Reports_Col_Lost_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lucros Cessantes`)
};

/**
* | output |
* | --- |
* | "Lost income" |
*
* @param {Reports_Col_Lost_IncomeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_lost_income = /** @type {((inputs?: Reports_Col_Lost_IncomeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Lost_IncomeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_lost_income(inputs)
	return pt_br2_reports_col_lost_income(inputs)
});